import { FunctionComponent } from "react";

import {
  ProductsSelect,
  ProductsSelectProps
} from "../../pickers/ProductsSelect";
import { useFieldContext, useFieldRegister } from "@bps/fluent-ui";

type FormProductsSelectProps = Omit<
  ProductsSelectProps,
  "selectedKeys" | "onChangeSelectedKeys"
> & { name: string };

export const FormProductsSelect: FunctionComponent<FormProductsSelectProps> = ({
  name,
  ...restProductsSelectProps
}) => {
  useFieldRegister(name);
  const { value, setFieldValue, disabledForm } = useFieldContext<
    string | string[] | undefined
  >(name);

  return (
    <ProductsSelect
      selectedKeys={value}
      onChangeSelectedKeys={setFieldValue}
      {...restProductsSelectProps}
      disabled={disabledForm || restProductsSelectProps.disabled}
    />
  );
};
